<template>
    <div class="operation-log-panel">
        <div class="operation-log-toolbar">
            <div class="operation-log-toolbar-head">
                <div class="operation-log-title">
                    <i class="el-icon-tickets"></i>
                    <span>操作日志</span>
                    <span class="operation-log-count">共 {{ logTotal }} 条</span>
                </div>
                <el-button size="small" type="text" icon="el-icon-refresh" :loading="logLoading"
                    @click="fetchLogs">刷新日志</el-button>
            </div>
            <div class="operation-log-filters">
                <div class="operation-log-filter-item">
                    <span class="operation-log-filter-label">店铺</span>
                    <el-select v-model="logFilters.shop" filterable clearable placeholder="全部店铺"
                        class="operation-log-shop" size="small" @change="reloadFromFirstPage">
                        <el-option v-for="item in shopOptions" :key="item.value" :label="item.text" :value="item.value" />
                    </el-select>
                </div>
                <div class="operation-log-filter-item">
                    <span class="operation-log-filter-label">操作类型</span>
                    <el-select v-model="logFilters.action_type" filterable clearable placeholder="全部类型"
                        class="operation-log-action-type" size="small" @change="reloadFromFirstPage">
                        <el-option v-for="item in logActionTypes" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
                <div class="operation-log-filter-item">
                    <span class="operation-log-filter-label">操作人</span>
                    <el-input v-model="logFilters.username" placeholder="输入操作人" size="small"
                        class="operation-log-username" clearable @change="reloadFromFirstPage"
                        @keyup.enter.native="reloadFromFirstPage" />
                </div>
                <div class="operation-log-actions">
                    <el-button size="small" type="primary" icon="el-icon-search" @click="reloadFromFirstPage">
                        查询
                    </el-button>
                    <el-button size="small" icon="el-icon-refresh-left" @click="resetLogFilters">
                        重置
                    </el-button>
                </div>
            </div>
        </div>
        <el-table :data="logRows" size="small" max-height="500" border stripe v-loading="logLoading">
            <el-table-column prop="本地父体" label="本地父体" min-width="130" />
            <el-table-column prop="本地品名" label="本地品名" min-width="130" />
            <el-table-column prop="店铺" label="店铺" width="110" />
            <el-table-column prop="msku" label="MSKU" min-width="150" />
            <el-table-column prop="asin" label="ASIN" width="110" />
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                    <el-tag :type="logType(scope.row.action_type)" size="mini">
                        {{ scope.row.action_label || scope.row.action_type }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="username" label="操作人" width="100" align="center" />
            <el-table-column label="详情" min-width="220">
                <template slot-scope="scope">
                    <span style="font-size:12px;color:#909399;">{{ formatLogDetail(scope.row.detail) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="时间" width="165" />
        </el-table>
        <div class="operation-log-pagination">
            <el-pagination background layout="prev, pager, next, total" :total="logTotal" :page-size="logPageSize"
                :current-page="logPage" @current-change="onLogPageChange" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'OperationLogPanel',
    props: {
        active: { type: Boolean, default: false },
        parent: { type: String, default: '' },
        shop: { type: String, default: '' },
        shopOptions: { type: Array, default: () => [] },
    },
    data() {
        return {
            logLoading: false,
            logRows: [],
            logTotal: 0,
            logPage: 1,
            logPageSize: 20,
            logFilters: { shop: '', action_type: '', username: '' },
            logActionTypes: [
                { value: 'move_in', label: '移入' },
                { value: 'move_out', label: '移出' },
                { value: 'create_new_asin', label: '新建ASIN' },
                { value: 'create_follow', label: '创建跟卖' },
                { value: 'create_product', label: '创建产品' },
                { value: 'create_and_pair', label: '创建并配对' },
                { value: 'generate_msku', label: '批量生成MSKU' },
                { value: 'update_parent_config', label: '父体配置' },
                { value: 'batch_config', label: '批量导入配置' },
                { value: 'batch_update', label: '批量更新' },
                { value: 'update_state', label: '状态标记' },
            ],
        };
    },
    watch: {
        active: {
            immediate: true,
            handler(value) {
                if (value) this.reloadFromFirstPage();
            },
        },
    },
    methods: {
        reloadFromFirstPage() {
            this.logPage = 1;
            if (this.active) this.fetchLogs();
        },
        fetchLogs() {
            if (!this.active) return;
            this.logLoading = true;
            const params = {
                limit: this.logPageSize,
                offset: (this.logPage - 1) * this.logPageSize,
            };
            if (this.logFilters.shop) params.shop = this.logFilters.shop;
            if (this.logFilters.action_type) params.action_type = this.logFilters.action_type;
            if (this.logFilters.username) params.username = this.logFilters.username;
            if (this.parent) params.parent = this.parent;
            if (this.shop && !params.shop) params.shop = this.shop;
            this.$axios.get('/vue/vue_product/operation-log', { params }).then(res => {
                if (res.code === 200 && res.data) {
                    this.logRows = res.data.rows || [];
                    this.logTotal = res.data.total || 0;
                }
            }).catch(() => {
                this.$message.error('操作日志查询失败');
            }).finally(() => {
                this.logLoading = false;
            });
        },
        resetLogFilters() {
            this.logFilters = { shop: '', action_type: '', username: '' };
            this.reloadFromFirstPage();
        },
        onLogPageChange(page) {
            this.logPage = page;
            this.fetchLogs();
        },
        logType(type) {
            const types = {
                move_in: 'primary', move_out: 'warning', create_new_asin: 'success',
                create_follow: 'success', create_product: 'success',
                create_and_pair: 'success', generate_msku: 'warning',
                update_parent_config: 'info', batch_config: 'info',
                batch_update: 'info', update_state: 'info',
            };
            return types[type] || 'info';
        },
        formatLogDetail(detail) {
            if (!detail) return '';
            if (typeof detail === 'string') return detail;
            return Object.keys(detail).map(key => {
                const value = detail[key];
                return key + '=' + (value && typeof value === 'object' ? JSON.stringify(value) : value);
            }).join('；');
        },
    },
};
</script>

<style scoped>
.operation-log-toolbar {
    padding: 12px 14px;
    margin-bottom: 12px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    background: linear-gradient(180deg, #fafcff 0%, #ffffff 100%);
}

.operation-log-toolbar-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 28px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f2f5;
}

.operation-log-title {
    display: inline-flex;
    align-items: center;
    color: #303133;
    font-size: 14px;
    font-weight: 600;
}

.operation-log-title > i {
    margin-right: 6px;
    color: #409eff;
    font-size: 16px;
}

.operation-log-count {
    margin-left: 10px;
    color: #909399;
    font-size: 12px;
    font-weight: normal;
}

.operation-log-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px 18px;
    padding-top: 12px;
}

.operation-log-filter-item {
    display: inline-flex;
    align-items: center;
}

.operation-log-filter-label {
    flex: 0 0 auto;
    margin-right: 7px;
    color: #606266;
    font-size: 13px;
    white-space: nowrap;
}

.operation-log-shop {
    width: 180px;
}

.operation-log-action-type {
    width: 150px;
}

.operation-log-username {
    width: 150px;
}

.operation-log-actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    padding-left: 18px;
    border-left: 1px solid #ebeef5;
}

.operation-log-pagination {
    text-align: right;
    margin-top: 8px;
    margin-bottom: 12px;
}

@media (max-width: 900px) {
    .operation-log-actions {
        width: 100%;
        margin-left: 0;
        padding-left: 0;
        border-left: 0;
    }
}
</style>
